import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Scrollable, ScrollBehavior} from "@mintdata-wsp/wsp/ui/components/scrollable/Scrollable";

const styles = require('./SettingsScroll.less');
const cx = classnames.bind(styles);

// export interface SettingsScrollProps
// {
//     className?:string;
// }

@observer
export class SettingsScroll extends React.Component<any, any>
{
    render()
    {
        return (
            <Column className={cx('scrollWrapper')}>

                <Scrollable
                    className={styles.bgTransparent}
                    isScrollX={false}
                    isScrollY={true}
                    behavior={ScrollBehavior.OnHover}
                    >

                    <Column className={cx('scrollInner')}>
                        {this.props.children}
                    </Column>

                </Scrollable>

            </Column>
        );
    }
}





